// src/components/common/LoadingSpinner.js

import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="flex justify-center items-center py-8">
      <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-indigo-600"></div>
      <span className="ml-4 text-lg font-medium text-gray-700">Loading...</span>
    </div>
  );
};

export default LoadingSpinner;
